// Raw API functions for the Shopify → Account onboarding flow.
//
// `get` comes from `utils/api` — the shared axios instance whose baseURL is
// `${origin}/api` (see src/utils/api.js `getAxiosInstance`). So `get('/v3/...')`
// resolves to `${origin}/api/v3/...` — never add a leading `/api` here.
//
// NOTE: `PATCH /v3/shopify_orders/:id/auth_token` is intentionally NOT wrapped
// here. That call — which obtains the anonymous member holding the purchase — is
// already owned by AuthMember (src/auth/member.js:getPatchDetails), which runs it
// at `/?orderId=...` before redirecting into this flow. Calling it again from this
// page would re-claim an order that has already been claimed.

import { get } from 'utils/api';

// GET /v3/shopify_orders/:orderId
// Polled by `usePollShopifyOrder` (see ./hooks.js) while the purchase's
// entitlements are still being provisioned server-side.
export const getShopifyOrder = orderId => get(`/v3/shopify_orders/${orderId}`);
